import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiService } from '../services/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHand,
  faFileLines,
  faUsers,
  faPlus,
  faFile,
  faImages,
  faUserPlus,
  faChartLine,
  faEye
} from '@fortawesome/free-solid-svg-icons';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    total_posts: 0,
    posts_this_week: 0,
    total_users: 0,
    total_categories: 0,
    published_posts: 0,
    draft_posts: 0,
    total_visits: 0,
    recent_posts: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await apiService.getDashboardStats();
      setStats(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error loading stats:', error);
      setLoading(false);
    }
  };

  return (
    <>
          {/* Welcome Section */}
          <div className="admin-welcome">
            <h2>
              Welcome back, {user?.name}! <FontAwesomeIcon icon={faHand} style={{ color: '#f59e0b' }} />
            </h2>
            <p>Here's what's happening with your blog today.</p>
          </div>

          {/* Stats Cards */}
          <div className="admin-stats-grid">
            <div className="admin-stat-card">
              <div className="admin-stat-icon">
                <FontAwesomeIcon icon={faFileLines} />
              </div>
              <div className="admin-stat-content">
                <h3>Total Posts</h3>
                <p className="admin-stat-number">
                  {loading ? '...' : <AnimatedCounter end={stats.total_posts} />}
                </p>
                <span className={`admin-stat-change ${stats.posts_this_week > 0 ? 'positive' : ''}`}>
                  +{stats.posts_this_week} this week
                </span>
              </div>
            </div>

            <div className="admin-stat-card">
              <div className="admin-stat-icon">
                <FontAwesomeIcon icon={faChartLine} />
              </div>
              <div className="admin-stat-content">
                <h3>Published</h3>
                <p className="admin-stat-number">
                  {loading ? '...' : <AnimatedCounter end={stats.published_posts} />}
                </p>
                <span className="admin-stat-change">
                  {stats.draft_posts} drafts
                </span>
              </div>
            </div>

            <div className="admin-stat-card">
              <div className="admin-stat-icon">
                <FontAwesomeIcon icon={faEye} />
              </div>
              <div className="admin-stat-content">
                <h3>Total Visits</h3>
                <p className="admin-stat-number">
                  {loading ? '...' : <AnimatedCounter end={stats.total_visits} />}
                </p>
                <span className="admin-stat-change">Blog views</span>
              </div>
            </div>

            <div className="admin-stat-card">
              <div className="admin-stat-icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <div className="admin-stat-content">
                <h3>Users</h3>
                <p className="admin-stat-number">
                  {loading ? '...' : <AnimatedCounter end={stats.total_users} />}
                </p>
                <span className="admin-stat-change">Active admins</span>
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="admin-section">
            <h3>Recent Activity</h3>
            <div className="admin-card">
              <p className="admin-empty-state">
                No recent activity. Start creating content to see updates here.
              </p>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="admin-section">
            <h3>Quick Actions</h3>
            <div className="admin-quick-actions">
              <button className="admin-action-btn">
                <span className="admin-action-icon">
                  <FontAwesomeIcon icon={faPlus} />
                </span>
                <span>New Post</span>
              </button>
              <button className="admin-action-btn">
                <span className="admin-action-icon">
                  <FontAwesomeIcon icon={faFile} />
                </span>
                <span>New Page</span>
              </button>
              <button className="admin-action-btn">
                <span className="admin-action-icon">
                  <FontAwesomeIcon icon={faImages} />
                </span>
                <span>Upload Media</span>
              </button>
              <button className="admin-action-btn">
                <span className="admin-action-icon">
                  <FontAwesomeIcon icon={faUserPlus} />
                </span>
                <span>Add User</span>
              </button>
            </div>
          </div>
    </>
  );
};

// Animated Counter Component
const AnimatedCounter = ({ end, duration = 1000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const progress = (currentTime - startTime) / duration;

      if (progress < 1) {
        setCount(Math.floor(end * progress));
        animationFrame = requestAnimationFrame(animate);
      } else {
        setCount(end);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [end, duration]);

  return <span>{count}</span>;
};

export default AdminDashboard;
